import api from './api'

/**
 * Serviço de Usuários do Tenant (TENANT_ADMIN)
 * 
 * Backend: /api/tenant/users
 */
export default {
  /**
   * Listar usuários do tenant
   * GET /api/tenant/users?perfil=&status=&busca=
   */
  list(params = {}) {
    return api.get('/api/tenant/users', { params })
  },

  /**
   * Convidar novo usuário
   * POST /api/tenant/users/invite
   */
  invite(data) {
    return api.post('/api/tenant/users/invite', data)
  },

  /**
   * Editar usuário
   * PUT /api/tenant/users/{id}
   */
  update(userId, data) {
    return api.put(`/api/tenant/users/${userId}`, data)
  },

  /**
   * Ativar/Desativar usuário
   * PATCH /api/tenant/users/{id}/toggle-status
   */
  toggleStatus(userId) {
    return api.patch(`/api/tenant/users/${userId}/toggle-status`)
  },

  /**
   * Remover usuário
   * DELETE /api/tenant/users/{id}
   */
  remove(userId) {
    return api.delete(`/api/tenant/users/${userId}`)
  },

  /**
   * Contadores de usuários
   * GET /api/tenant/users/stats
   */
  stats() {
    return api.get('/api/tenant/users/stats')
  },
}
